//@ts-check

const onResize = () => {
    const $win = $(window);
    const mobileWidth = 991;
    let isMobile = $win.width() <= mobileWidth;
    $win.on('resize', (evt) => {
        isMobile = $win.width() <= mobileWidth;
        console.log(`Width: ${$win.width()} is ${isMobile ? ' ' : ' not '}a Mobile.`);
    });
};

class FinancialsService {
    constructor(
        $sce,
        $http,
        Utility,
        $window,
        $timeout,
        $rootScope,
        $templateCache,
        TelemetryService,
        NotificationService,
        LocalStorageService,
        InternalLinksService
    ) {
        this.$sce = $sce;
        this.$http = $http;
        this.Utility = Utility;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$templateCache = $templateCache;
        this.TelemetryService = TelemetryService;
        this.NotificationService = NotificationService;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;

        this.init();
    }

    init() {
        this.$win = $(this.$window);
        this.financialYears = undefined;
        this.financialMonths = undefined;
        this.LastFinancialMonth = undefined;
        this.iframeReportUrl = undefined;
        this.Utility.safeApply(this.$rootScope, onResize);
        this.mobileViewText =
            'Kindly download the PDF report as we do not have a mobile view for this report as of yet.';
        this.buildingWorkflowAndFeatures = {};
    }

    getSelectedDate(originalDate) {
        if (originalDate) {
            return originalDate;
        }

        let selectedDate;
        if (this.LocalStorageService.retrieve('selectedReportMonth')) {
            const rawSelectedReportMonth = this.LocalStorageService.retrieve('selectedReportMonth');
            selectedDate = moment(rawSelectedReportMonth, 'YYYY-MM-DD');
        } else {
            selectedDate = moment(new Date(), 'YYYY-MM-DD');
        }

        return selectedDate;
    }

    getSelectedYear(originalDate) {
        if (originalDate) {
            return originalDate;
        }

        let selectedDate;
        if (this.LocalStorageService.retrieve('selectedReportYear')) {
            const rawSelectedReportYear = this.LocalStorageService.retrieve('selectedReportYear');
            selectedDate = moment(rawSelectedReportYear, 'YYYY-MM-DD');
        } else {
            selectedDate = moment(new Date(), 'YYYY-MM-DD');
        }

        return selectedDate;
    }

    getSelectedMonth(originalDate) {
        if (originalDate) {
            return originalDate;
        }

        let selectedDate;
        if (this.LocalStorageService.retrieve('selectedReportMonth')) {
            const rawSelectedReportMonth = this.LocalStorageService.retrieve('selectedReportMonth');
            selectedDate = moment(rawSelectedReportMonth, 'YYYY-MM-DD');
        } else {
            selectedDate = moment(new Date(), 'YYYY-MM-DD');
        }

        return selectedDate;
    }

    async setReportURL(schemeRef, date) {
        let url = await this.InternalLinksService.getLink('FinancialsReport');
        let formattedDate;
        try {

            if (!url) {
                await this.InternalLinksService.getLinks('/api/reporting/links');
                url = await this.InternalLinksService.getLink('FinancialsReport');
            }
            if (typeof date === 'object') {
                if ('getDate' in date) {
                    const intDay = date.getDate();
                    const intMonth = date.getMonth() + 1;
                    const year = date.getFullYear();

                    let strDay = `${intDay}`.length > 1 ? `${intDay}` : `0${intDay}`;
                    let strMonth = `${intMonth}`.length > 1 ? `${intMonth}` : `0${intMonth}`;
                    formattedDate = `${strMonth}/${strDay}/${year}`;
                } else {
                    formattedDate = date.format('MM/DD/YYYY');
                }
            } else {
                const strDate = date.substr(0, 10);
                formattedDate = moment(strDate).format('MM/DD/YYYY');
            }
            url += `?schemeRef=${schemeRef}&date=${formattedDate}&type=${0}`;

        } catch (err) {
            this.NotificationService.error('Error Downloading Report');
        } finally {
            return url;
        }
    }

    getMapFirstDay(originalDate) {
        if (!originalDate.year) {
            originalDate = moment(originalDate);
        }

        const todayMoment = moment(`${originalDate.year()}-01-${originalDate.month() + 1}`, 'YYYY-DD-MM').add(3, 'h');

        return todayMoment.toDate();
    }

    async getFinancialYears(schemeRef, date) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });
            let url = await this.InternalLinksService.getLink('FinancialApiFinancialYears');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                url = await this.InternalLinksService.getLink('FinancialApiFinancialYears');
            }

            url = url.replace('{schemeRef}', schemeRef).trim();

            const headers = this.Utility.headersWithContentType;
            const results = await this.$http.post(url, date, { headers: headers });
            const { data } = results;

            this.financialYears = data;
            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.financialYears = {};
            this.$timeout(() => promiseHandler.resolve());
        }

        return promise;
    }

    async getLastFinancialMonth(schemeRef) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialApiLastFinancialMonth');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                url = await this.InternalLinksService.getLink('FinancialApiLastFinancialMonth');
            }

            url = url.replace('{schemeRef}', schemeRef).trim();

            const headers = this.Utility.headersWithContentType;
            const results = await this.$http.post(url, { headers });
            const { data } = results;

            this.financialMonths = data;
            this.$timeout(() => promiseHandler.resolve(data));
        } catch (err) {
            this.financialMonths = {};
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }


    async getFinancialMonths(schemeRef, date) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialApiFinancialMonths');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                url = await this.InternalLinksService.getLink('FinancialApiFinancialMonths');
            }

            url = url.replace('{schemeRef}', schemeRef).trim();

            const headers = this.Utility.headersWithContentType;
            const results = await this.$http.post(url, date, { headers });
            const { data } = results;

            this.financialMonths = data;
            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.financialMonths = {};
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getReport(schemeRef, date, type, title, orderByUnitNumber, onlyShowDebtors, showLegalMemos, showAllLegalAccounts) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialsReport');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/reporting/links');
                url = await this.InternalLinksService.getLink('FinancialsReport');
            }
            let formattedDate;

            if (typeof date === 'object') {
                if ('getDate' in date) {
                    const intDay = date.getDate();
                    const intMonth = date.getMonth() + 1;
                    const year = date.getFullYear();

                    let strDay = `${intDay}`.length > 1 ? `${intDay}` : `0${intDay}`;
                    let strMonth = `${intMonth}`.length > 1 ? `${intMonth}` : `0${intMonth}`;
                    formattedDate = `${strMonth}/${strDay}/${year}`;
                } else {
                    formattedDate = date.format('MM/DD/YYYY');
                }
            } else {
                const strDate = date.substr(0, 10);
                formattedDate = moment(strDate).format('MM/DD/YYYY');
            }

            if (type === 3 || type === 7) {
                url += `?schemeRef=${schemeRef}&date=${formattedDate}&type=${type}&orderByUnitNumber=${orderByUnitNumber ||
                    false}&onlyShowDebtors=${onlyShowDebtors || false}&showLegalMemos=${showLegalMemos || false}&showAllLegalAccounts=${showAllLegalAccounts || false}`;
            } else {
                url += `?schemeRef=${schemeRef}&date=${formattedDate}&type=${type}`;
            }
            this.openNewTabReport(url, title);

            await this.TelemetryService.logTelemetry(
                `Download Financial Report`,
                `Report Type: ${type}, Scheme Ref: ${schemeRef}, Date: ${formattedDate}`
            );
            this.$timeout(() => promiseHandler.resolve());
        } catch (error) {
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    async getAllReports(schemeRef, date, onlyLevyRoll, type, title, orderByUnitNumber, onlyShowDebtors, showLegalMemos, showAllLegalAccounts) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('AllFinancialsReport');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/reporting/links');
                url = await this.InternalLinksService.getLink('AllFinancialsReport');
            }
            let formattedDate;

            if (typeof date === 'object') {
                if ('getDate' in date) {
                    const intDay = date.getDate();
                    const intMonth = date.getMonth() + 1;
                    const year = date.getFullYear();

                    let strDay = `${intDay}`.length > 1 ? `${intDay}` : `0${intDay}`;
                    let strMonth = `${intMonth}`.length > 1 ? `${intMonth}` : `0${intMonth}`;
                    formattedDate = `${strMonth}/${strDay}/${year}`;
                } else {
                    formattedDate = date.format('MM/DD/YYYY');
                }
            } else {
                const strDate = date.substr(0, 10);
                formattedDate = moment(strDate).format('MM/DD/YYYY');
            }

            if (type === 3) {
                url += `?schemeRef=${schemeRef}&date=${formattedDate}&type=${type}&orderByUnitNumber=${orderByUnitNumber ||
                    false}&onlyShowDebtors=${onlyShowDebtors || false}&showLegalMemos=${showLegalMemos || false}&showAllLegalAccounts=${showAllLegalAccounts || false}`;
            } else {
                url += `?schemeRef=${schemeRef}&date=${formattedDate}&onlyLevyRoll=${onlyLevyRoll}&type=${type}`;
            }
            this.openNewTabReport(url, title);

            await this.TelemetryService.logTelemetry(
                `Download All Financial Report`,
                `Report Type: ${type}, Scheme Ref: ${schemeRef}, Date: ${formattedDate}, OnlyLevyRoll: ${onlyLevyRoll}`
            );
            this.$timeout(() => promiseHandler.resolve());
        } catch (error) {
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    //TODO: async-await
    async getLegalReport(cardCode) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialsLegalReport');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/reporting/links');
                url = await this.InternalLinksService.getLink('FinancialsLegalReport');
            }
            url += `?cardCode=${cardCode}`;
            this.openNewTabReport(url, `Legal Report - ${cardCode}`);

            this.$timeout(() => promiseHandler.resolve());
        } catch (error) {
            console.error(`Error while Getting Legal Report: ${cardCode}`);
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    async getAllLegalReport(schemeRef, numberOfDays) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialsLegalReportAll');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/reporting/links');
                url = await this.InternalLinksService.getLink('FinancialsLegalReportAll');
            }
            url += `?schemeRef=${schemeRef}&numberOfDays=${numberOfDays}`;
            this.openNewTabReport(url, `Legal Report`);

            this.$timeout(() => promiseHandler.resolve());
        } catch (error) {
            console.error(`Error while Getting All Legal Report: ${schemeRef}`);
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    async getFinancialState(schemeRef, date, type) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialState');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/reporting/links');
                url = await this.InternalLinksService.getLink('FinancialState');
            }

            url = url.replace('{date}', date).replace('{type}', type).replace('{schemeRef}', schemeRef);

            const headers = this.Utility.headersWithContentType;
            if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
                const error = `Could not load Financial State the 'Username' and/or 'Session Token' is missing`;
                this.$timeout(() => promiseHandler.reject(error));
            }

            var rawResults = await this.$http.get(url, { headers });
            const { Data: httpCallResults, WasSuccessful } = rawResults.data;

            let status;
            if (WasSuccessful) {
                const { FinancialStatus } = httpCallResults;
                status = FinancialStatus;
            } else {
                status = -1;
            }

            const momentDate = moment(date, 'YYYY-MM-DD');
            const results = this._generateFinancialStatusResults(status, momentDate.format('MMM YYYY'), type);
            this.$timeout(() => promiseHandler.resolve(results));
        } catch (error) {
            console.error(`Error while retrieving financial details type (${type}) current state for date ${date}`);
            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }

    _generateFinancialStatusResults(status, month, type) {
        /*
        No Financial Release = -1
        Initial = 0,
        Approved = 1,
        Rejected = 2,
        SentForApproval = 3
        */

        /*
        CashflowStatment = 0,
        IncomeStatment = 1,
        BalanceSheet = 2,
        LevyRoll = 3,
        ContractorsRoll = 4,
        LegalReport = 5,
        CashAvailability = 6
        */

        let message, financialType;

        switch (type) {
            case 0:
                financialType = 'Cashflow Statement';
                break;
            case 1:
                financialType = 'Income Statement';
                break;
            case 2:
                financialType = 'Balance Sheet';
                break;
            case 3:
                financialType = 'Levy Roll';
                break;
            case 4:
                financialType = 'Contractors Roll';
                break;
            case 5:
                financialType = 'Legal Report';
                break;
            case 6:
                financialType = 'Cash Availability Report';
                break;
            case 7:
                financialType = 'Wages Roll';
                break;
            case 8:
                financialType = 'Debtor Age Analysis';
                break;
        }

        switch (status) {
            case 0:
            case 2:
            case 3:
                message = `Please take note, the ${financialType} for ${month} has not yet been finalized.`;
                break;
            case -1:
                message = `Please take note, the ${financialType} for ${month} has not yet been published.`;
                break;
        }

        return {
            status,
            message
        };
    }

    openNewTabReport(url, title) {
        const newTab = this.$window.open('', '_blank');
        if (!newTab) {
            this.NotificationService.error('Please allow pop-ups for this site to view the report');
            return;
        }

        newTab.document.write(`
        <html>
        <head>
            <title>${title}</title>
            <style>
                html, body {
                    margin: 0;
                    padding: 0;
                    overflow: hidden;
                    height: 100%;
                }
                iframe {
                    width: 100%;
                    height: 100%;
                    border: none;
                }
                #loadSpinner {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    text-align: center;
                }
            </style>
        </head>
        <body>
            <section id="loadSpinner">
                <img src="https://ptgweblivestaging.pretor.co.za:444/images/pretor.gif" alt="Loading...">
            </section>
            <iframe id="reportFrame" src="${url}" style="display:none;"></iframe>
            <script>
                const iframe = document.getElementById('reportFrame');
                const spinner = document.getElementById('loadSpinner');
                
                iframe.onload = function() {
                    spinner.remove();
                    iframe.style.display = 'block';
                };
            </script>
        </body>
        </html>
        `);
        newTab.document.close();
    }

    getTemplate(templatePath) {
        const htmlTemplate = this.$templateCache.get(templatePath);
        return htmlTemplate;
    }


    async getbuildingWorkflowAndFeatures(schemeRef) {
        let promiseHandler = {};
        const promise = new Promise((resolve, reject) => {
            promiseHandler = {
                reject,
                resolve
            };
        });

        try {
            let url = await this.InternalLinksService.getLink('BuildingWorkflowAndFeatures');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                url = await this.InternalLinksService.getLink('BuildingWorkflowAndFeatures');
            }
            url = url.replace('{schemeRef}', schemeRef).trim();

            const headers = this.Utility.headersWithContentType;

            const results = await this.$http.get(url, { headers });
            const { data } = results;
            this.buildingWorkflowAndFeatures = !!data ? data : {};

            this.$timeout(() => {
                promiseHandler.resolve();
            });
        } catch (err) {
            this.buildingWorkflowAndFeatures = {};
            this.$timeout(() => {
                promiseHandler.reject(err);
            });
        }
        return promise;
    }
}

export default /* @ngInject */ (
    $sce,
    $http,
    Utility,
    $window,
    $timeout,
    $rootScope,
    $templateCache,
    TelemetryService,
    NotificationService,
    LocalStorageService,
    InternalLinksService
) =>
    new FinancialsService(
        $sce,
        $http,
        Utility,
        $window,
        $timeout,
        $rootScope,
        $templateCache,
        TelemetryService,
        NotificationService,
        LocalStorageService,
        InternalLinksService
    );
